export default __webpack_public_path__ + "static/media/phone.e8dcf355.svg";